<template>
  <el-container class="InboundForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="70px"
        class="form-label-70"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                :disabled="!!customer"
                buyer
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="매입일" prop="inbound_date">
              <ADatePicker v-model="data.inbound_date" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="발주일" prop="order_date">
              <ADatePicker v-model="data.order_date" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ATradeTable
        ref="trade"
        :items="data.details"
        :customer="customer"
        disableSizeAmount
        @changedSum="handleChangedSum"
      />
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        v-if="is_new"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >등록 (F4)</el-button
      >
      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import { inbound_form } from "@/common/mixins/inbound_form";

export default {
  name: "InboundForm",
  mixins: [form, inbound_form],
  data() {
    return {
      title: "매입",
      sum: 0,
      rules: {
        customer_name: [{ required: true, message: "거래처를 선택해 주세요." }],
        inbound_date: [{ required: true, message: "매입일을 선택해 주세요." }],
      },
      temp_customer: null,
      working: false,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          code: "",
          customer_id: 0,
          customer_name: "",
          zipcode: "",
          destination: "",
          inbound_date: this.util.getDate(0),
          order_date: null,
          price: 0,
          details: [],
        };
      },
    },
    customer: {
      type: Object,
      default: null,
    },
  },
  computed: {
    is_new: function() {
      return this.data.id < 1;
    },
  },
  mounted() {
    if (!this.customer) {
      return;
    }
    let c = this.customer;
    this.temp_customer = c;
    this.data.customer_id = c.id;
    this.data.customer_name = c.name;
  },
  methods: {
    doRegister() {
      const trades = this.$refs.trade.result();
      const details = [];
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_name && !trades[i].amount) {
          continue;
        }
        let detail = Object.assign({}, trades[i]);
        detail.seq = i + 1;
        details.push(detail);
      }
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = details;
      this.load_button = true;
      this.api.createInbound(data).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed", true);
      });
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.temp_customer = null;
        this.data.customer_id = null;
        this.data.customer_name = c;
      } else {
        this.temp_customer = c;
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickRegister() {
      if (this.working) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        let details = this.getDetails();
        if (details.length < 1) {
          this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }

        const supply_prices = details.filter((x) => x.supply_price === null);
        if (supply_prices.length) {
          supply_prices.map((p) => {
            this.util.notify_warning(
              this,
              this.title,
              "품명 " +
                p.product_name +
                "의 단가가 입력되지 않았습니다. 입력해 주시기 바랍니다."
            );
          });
          return;
        }
        this.working = true;
        if (this.isNew && this.util.isPastDate(this.data.inbound_date)) {
          this.util.confirm(
            this,
            this.title,
            "매입일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        this.doRegister();
      });
    },
  },
};
</script>
